export const DOM_EVENTS = {
  // Keyboard events
  KEYDOWN: "keydown",
  KEYUP: "keyup",
  KEYPRESS: "keypress",

  // Mouse events
  CLICK: "click",
  MOUSEDOWN: "mousedown",
  MOUSEUP: "mouseup",
  MOUSEMOVE: "mousemove",
  MOUSELEAVE: "mouseleave",
  MOUSEENTER: "mouseenter",
  MOUSEOVER: "mouseover",
  MOUSEOUT: "mouseout",

  // Touch events
  TOUCHSTART: "touchstart",
  TOUCHMOVE: "touchmove",
  TOUCHEND: "touchend",
  TOUCHCANCEL: "touchcancel",

  // Drag events
  DRAG: "drag",
  DRAGSTART: "dragstart",
  DRAGEND: "dragend",
  DRAGENTER: "dragenter",
  DRAGLEAVE: "dragleave",
  DRAGOVER: "dragover",
  DROP: "drop",

  // Focus events
  FOCUS: "focus",
  BLUR: "blur",
  FOCUSIN: "focusin",
  FOCUSOUT: "focusout",

  // Form events
  CHANGE: "change",
  INPUT: "input",
  SUBMIT: "submit",
  RESET: "reset",

  // Window/Document events
  SCROLL: "scroll",
  RESIZE: "resize",
  LOAD: "load",
  UNLOAD: "unload",
  BEFOREUNLOAD: "beforeunload",
  POPSTATE: "popstate",
  ORIENTATIONCHANGE: "orientationchange",

  // Media events
  ENDED: "ended",
  PLAY: "play",
  PAUSE: "pause",
  TIMEUPDATE: "timeupdate",
  VOLUMECHANGE: "volumechange",

  // Other
  CONTEXTMENU: "contextmenu",
  WHEEL: "wheel",
  ERROR: "error",
} as const;

export type DOMEventName = (typeof DOM_EVENTS)[keyof typeof DOM_EVENTS];

export const KEYBOARD_KEYS = {
  // Navigation keys
  ARROW_LEFT: "ArrowLeft",
  ARROW_RIGHT: "ArrowRight",
  ARROW_UP: "ArrowUp",
  ARROW_DOWN: "ArrowDown",
  HOME: "Home",
  END: "End",
  PAGE_UP: "PageUp",
  PAGE_DOWN: "PageDown",

  // Action keys
  ENTER: "Enter",
  ESCAPE: "Escape",
  TAB: "Tab",
  SPACE: " ",
  BACKSPACE: "Backspace",
  DELETE: "Delete",

  // Modifier keys
  SHIFT: "Shift",
  CONTROL: "Control",
  ALT: "Alt",
  META: "Meta",

  // Function keys
  F1: "F1",
  F2: "F2",
  F3: "F3",
  F4: "F4",
  F5: "F5",
  F6: "F6",
  F7: "F7",
  F8: "F8",
  F9: "F9",
  F10: "F10",
  F11: "F11",
  F12: "F12",
} as const;

export type KeyboardKey = (typeof KEYBOARD_KEYS)[keyof typeof KEYBOARD_KEYS];
